import { Loading } from 'element-ui'
const mapList_must = ['province', 'city', 'county', 'town', 'village']
export default {
  data() {
    return {
      filterForm: {}, // 筛选数据
      tableData: [], // 表格数据
      tableDataCopy: [], // 表格数据
      selectRows: [], // 表格选中行数据
      selectData: {}, // 表格选中行编辑数据
      // areaIdsChecked: [], // 表格选中行编辑地区数据 => 替换筛选地区数据

      isCreate: false,
      dialogType: 1, // 1创建 2编辑 3查看

      btnShow: {
        search: false,
        create: false,
        modify: false,
        delete: false,
        import: false,
        export: false,
        migration: false,
        assign: false,
        transfer: false,
      }, // 权限显隐
      
      pageData: {
        currentPage: 1,
        pageSize: 40,
        total: 0,
      }, // 页码数据

      //  导入 与 下载 
      importFiles: [],
      isShowImportTip: false,
      loadingInstance: '',
      importResult: '',

      // 排序
      mapList_must: mapList_must,
      tableSearchAreaId: '',
      tableSortAreaId: '',
      tableSortData: {},
      tableSortClickSetting: false,
    }
  },
  computed: {
    areaPickerRef() {
      let result = this.$refs.AreaPicker
      if (!result) {
        // 兼容新版FilterBox组件
        const domFilterBox = this.$refs.FilterBox
        if (!domFilterBox) return null
        result = domFilterBox.$refs.AreaPicker
        if (Array.isArray(result)) return result[0]
        return result
      }
      if (Array.isArray(result)) return result[0]
      return result
    },
    tableRef() {
      let result = this.$refs.TableRef
      if (!result) {
        // 兼容新版TableBox组件
        const domTableBox = this.$refs.TableBox
        if (!domTableBox) return null
        result = domTableBox.$refs.TableRef
        if (Array.isArray(result)) return result[0]
        return result
      }
      if (Array.isArray(result)) return result[0]
      return result
    },
  },
  methods: {
    // #region 导入与下载
    // 导入前
    beforeImport(file) {
      console.log(file)
      this.loadingInstance = Loading.service({
        lock: true,
        text: '导入中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        fullscreen: true 
      })
    },
    // 导入成功
    importSuccess(response, file, fileList) {
      console.log(`%cresponse:`, 'color: #f00;', response)
      this.$nextTick(() => {
        this.loadingInstance.close()
      }) // 以服务的方式调用的 Loading 需要异步关闭
      switch (response.status) {
        case 0:
          if (response.data) {
            // this._tips({message:'上传成功'})
            let result = JSON.parse(response.data)
            console.log(result)
            let failDataList = JSON.parse(result.failedResult)
            console.log(failDataList)
            console.log(`%c上传结果:`, 'color: #00f;', result)
            let failStr = ''
            if (result.failedCount !== 0) {
              console.log(`%c失败列表:`, 'color: #00f;', failDataList)
              failStr = `
                <p style="height:30px;line-height:30px;">导入失败 <strong style="color:red;">${result.failedCount}</strong> 条</p>
                <p style="margin-left:40px;height:30px;line-height:30px;">
                  <span>错误原因</span>
                  <span style="float:right;">错误数据</span>
                </p>
              `

              failDataList.forEach(x => {
                failStr += `
                  <div style="margin-left:40px;line-height:24px;border-top:1px solid #eee;">
                    <p>${x.error}</p>
                    <p style="text-align:right;">${this.importTiplabel}：<strong style="color:red;">${x[this.importTipKey]}</strong></p>
                  </div>
                `
              })
              // console.log(failDataList);
              
              // failStr += ' </p><p style="color:red;">* 可能造成的原因：地区错误 *</p>'
            }
            // if (result.duplicateCount !== 0) {
            //    failStr += '<p style="margin-left:20px;">重复数据 <strong style="color:red;">'+result.duplicateCount+'</strong> 条</p>'
            // }
            this.importResult = `<p style="height:30px;line-height:30px;">导入成功 <strong style="color:green;">${result.successCount+result.duplicateCount}</strong> 条</p>${failStr}`
            // this.$alert(code, '上传结果', { dangerouslyUseHTMLString: true })
            this.isShowImportTip = true
            this.importFiles = []
            this.filterClick()
          } else {
            this.importResult = `<p style="height:30px;line-height:30px;">导入成功！</p>`
            this.isShowImportTip = true
            this.importFiles = []
            this.filterClick()
          }
          break;
        case 1: this.$message.error('用户已被冻结'); break;
        case 2: this.$message.error('用户不存在'); break;
        case 3: this.$message.error('用户名或者密码错误'); break;
        case 4: this.$message.error('用户未登录'); break;
        case 5: this.$message.error('目录名已存在'); break;
        case 6: this.$message.error('不是管理员'); break;
        case 7: this.$message.error('系统错误'); break;
        case 8: this.$message.error('名称已存在'); break;
        case 9: this.$message.error('分站管理员已经存在'); break;
        case 10: this.$message.error('权限不够'); break;
        case 11: this.$message.error('权限不够'); break;
        case 12: this.$message.error('模板已过期'); break;
        case 36: case 37:
          this.$message.error('没有配置相关字段')
          this.isShowSetkeyword = true
          this.importFiles = []
          break;
      }
    },
    beforeSearchAndExportHandler(obj) {
      let rD = {}
      let keys = Object.keys(obj)
      if (keys.length > 0) {
        keys.forEach(x => {
          const type = Object.prototype.toString.call(obj[x])
          switch (type) {
            case '[object String]':
            case '[object Number]':
              obj[x] !== '' ? rD[x] = obj[x] : ''
              break;
            case '[object Array]':
              JSON.stringify(obj[x]) !== '[]' ? rD[x] = obj[x] : ''
              break;
            case '[object Object]':
              for (const key in obj[x]) {
                if (obj[x].hasOwnProperty(key)) {
                  const value = obj[x][key]
                  if (value) {
                    if (typeof rD[x] !== 'object') {
                      rD[x] = {}
                    }
                    rD[x][key] = obj[x][key]
                  }
                }
              }
              break;
          }
        })
      }
      return rD
    },
    // 导出
    exportClick(areaId) {
      areaId ? '' : areaId = this.areaPickerRef.findAreaId()
      console.log(`%cfilterForm:`, 'color: #00f;', this.filterForm)
      let rD = this.beforeSearchAndExportHandler(this.filterForm)

      if (areaId) {
        let loadingInstance = Loading.service({
          lock: true,
          text: '导出中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
          fullscreen: true 
        })
        rD.areaId = areaId
        this.$api.util_export(this.sign, rD).then(res => {
          if (res.data.status == 0) {
            let _R = res.data.data
            this.downloadFun(_R)
            this.$nextTick(() => { loadingInstance.close() })
          } else {
            this._status(res.data)
            this.$nextTick(() => { loadingInstance.close() })
          }
        })
      } else { this.$message.warning('请选择地区！') }
    },
    // 下载方法
    downloadFun(id) {
      var a = document.createElement('a')
      a.style.display = 'none'
      a.href = `${this.$api.baseUrl}/user/download/${id}`
      a.download = true
      // a.target = '_blank'
      document.body.appendChild(a)
      a.click()
    },
    // 下载模板
    downloadClick() {
      var a = document.createElement('a')
      a.style.display = 'none'
      a.href = `/xls/${this.fileName}.xls`
      a.download = `${this.fileName}.xls`
      // a.target = '_blank'
      document.body.appendChild(a)
      a.click()
    },
    // #endregion
    // 分页
    pageChange(pageNumer) {
      console.log(`%c调用了点击页码`, 'color: #f00;', )
      this.pageData.currentPage = pageNumer
      this.filterForm.pageNumber = pageNumer
      this.searchHandler()
    },
    // #region 基础
    // #region 筛选区
    // 地区变化
    areaChange(result) {
      console.log(result)
    },
    // 筛选
    filterClick(areaId) {
      console.log(`%c调用了筛选`, 'color: #f00;', areaId)
      this.tableSortClickSetting = false
      this.filterClickBefore && this.filterClickBefore()
      this.pageData.currentPage = 1
      this.searchHandler(areaId)
    },
    getFilterData(areaId) {
      console.log(`%c调用了查询`, 'color: #f00;', areaId)
      areaId ? '' : areaId = this.areaPickerRef.findAreaId()
      this.tableSearchAreaId = areaId
      const rD = this.beforeSearchAndExportHandler(this.filterForm)

      if (!areaId && !this.searchCanEmpty) {
        this.$message.warning('请选择地区！')
        return false
      }
      if (areaId) {
        rD.areaId = areaId
        rD.pageNumber = this.pageData.currentPage
      } else if (this.searchCanEmpty) {
        rD.pageNumber = this.pageData.currentPage
      }

      const items = this.formItems.filter(x1 => x1.fType === 'xy_daterange')
      items.forEach(x1 => {
        const key = x1.key
        const val = rD[key]
        if (val && val.length === 2) {
          if (x1.keys && x1.keys.length === 2) {
            rD[x1.keys[0]] = val[0]
            rD[x1.keys[1]] = val[1]
          } else {
            const keyOther = key.charAt(0).toUpperCase() + key.slice(1)
            rD['start' + keyOther] = val[0]
            rD['end' + keyOther] = val[1]
          }
          delete rD[key]
        }
      })
      console.log(`%c查询参数`, 'color: #f00;', rD)

      return rD
    },
    // 查询
    async searchHandler(areaId) {
      const rD = this.getFilterData(areaId)
      if (!rD) return
      const res = await this.getData(rD)
      if (!res) return
      this.tableData.forEach(x1 => {
        x1['fixed-area'] = x1.province + x1.city + x1.county + x1.town + x1.village
      })
      this.tableDataCopy = JSON.parse(JSON.stringify(this.tableData))
      this.pageData.total = res.data.size
      this.selectRows = []
      this.selectData = {}
    },
    // 重置筛选
    resetClick() {
      if (this.formItems) {
        for (const e of this.formItems) {
          const defaultValue = e.fDefault || e.default
          if (defaultValue) {
            if (typeof defaultValue === 'function') {
              this.$set(this.filterForm, e.key, defaultValue())
            } else {
              this.$set(this.filterForm, e.key, defaultValue)
            }
          } else {
            this.filterForm[e.key] = undefined
          }
        }
      }
      if (this.areaPickerRef) {
        this.areaPickerRef.reset()
      }
    },
    // #endregion
    // #region 按钮区
    // 点击选中
    currentChange(cRow, oRow) {
      // console.log(`%ccRow, oRow:`, 'color: #f00;', cRow, oRow)
      this.tableRef.clearSelection();
      this.tableRef.toggleRowSelection(cRow);
      this.selectData = JSON.parse(JSON.stringify(cRow))
    },
    // 勾选选中
    selectionChange(cRows) {
      // console.log(`%ccRows:`, 'color: #f00;', cRows)
      this.selectRows = JSON.parse(JSON.stringify(cRows))
      if (cRows.length === 1) {
        this.selectData = this.selectRows[0]
      }
    },
    // 删除
    deleteClick() {
      console.log(`%c调用了删除`, 'color: #f00;', )
      let ids = this.selectRows.map(x => x.id)
      let rD = { ids }
      if (this.selectRows.length > 0) {
        this.$confirm('确认删除数据？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.util_delete(this.sign, rD).then(res => {
            if (res.data.status === 0 ) {
              this.$message.success('删除成功！')
              // —————————————————— 把当前页的所有数据都删除时，需要更换页码 s ——————————————————
              let nowtotal = this.pageData.total - ids.length
              if (nowtotal % this.pageData.pageSize === 0) {
                if (this.pageData.currentPage > 1) {
                  this.pageData.currentPage--
                } else {
                  this.pageData.currentPage = 1
                }
              }
              // —————————————————— 把当前页的所有数据都删除时，需要更换页码 e ——————————————————
              console.log('删除后总条数',nowtotal,'当前页数',this.pageData.currentPage)
              this.searchHandler()
            } else { this._status(res.data) }
          })
        }).catch(() => {})
      } else { this.$message.warning('请至少勾选一条数据！') }

    },
    // 新建
    createClick() {
      this.createClickBefore && this.createClickBefore()
      this.isCreate = true
      this.dialogType = 1
      this.$refs.DialogForm.open(this.dialogType)
    },
    // 修改
    modifyClick() {
      if (this.selectData) {
        this.modifyClickBefore && this.modifyClickBefore()
        this.isCreate = false
        this.dialogType = 2
        this.$refs.DialogForm.open(this.dialogType, this.selectData)
      }
    },
    // 查看
    viewClick() {
      if (this.selectData) {
        this.viewClickBefore && this.viewClickBefore()
        this.dialogType = 3
        this.$refs.DialogForm.open(this.dialogType, this.selectData)
      }
    },
    // 提交弹框
    dialogSubmitCb(mapList, otherParams) {
      console.log(`%c调用了提交弹框`, 'color: #f00;', )
      let item = this.selectRows[0]
      let rD = {}
      mapList.forEach(x => {
        if (item[x] !== this.selectData[x]) {
          rD[x] = this.selectData[x]
        }
      })
      if (JSON.stringify(rD) !== '{}') {
        rD.id = item.id
        if (otherParams) {
          Object.assign(rD, otherParams)
        }
        console.log(`%cthis.selectData:`, 'color: #f00;', this.selectData, rD)
        this.$api.util_modify(this.sign, rD).then(res => {
          if (res.data.status == 0) {
            this.$message.success('成功！')
            this.searchHandler()
            // this.dialogClose()
          } else { this._status(res.data) }
        })
      } else {
        console.log(`%c没有改变`, 'color: #f0f;')
        // this.dialogClose()
      }
    },
    // #endregion
    // 获取表格数据
    getDataCb(rD = {}) {
      this.$api.util_search(this.sign, rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          this.tableData = _R
          this.pageData.total = res.data.size
          console.log(`%c返回数据:`, 'color: #f00;', this.tableData)
        } else { this._status(res.data) }
      })
    },
    // #region 排序
    // 打开排序与显隐弹框（通用）
    async setSortClick(key = 'f') {
      if (key === 'f') {
      this.setFilterClickBefore && await this.setFilterClickBefore()
      } else if (key === 't') {
        this.setTableClickBefore && await this.setTableClickBefore()
      }
      this.$refs.DialogSort.open(this.formItems || [], key)
    },
    // 填充排序与显隐（通用）
    fillSortItems(list, key = 'f') {
      if (!list) return
      if (typeof list === 'string') {
        list = JSON.parse(list)
      }
      console.log(`%c用户保存的${key}项:`, 'color: #f00;', list)

      if (this.formItems) {
        let max = 0
        list.forEach((x1, i1) => {
          const ITEM = this.formItems.find(x2 => x2.key === x1.key) || {}
          ITEM[key + 'Checked'] = x1.status
          ITEM[key + 'Show'] = x1.status
          ITEM[key + 'Index'] = i1
          max = i1
        })
        this.formItems.forEach(x1 => {
          if (x1[key + 'Index'] === -1){
            x1[key + 'Index'] = max++
          }
        })
      }
    },
    // 排序与显隐弹框提交（筛选项+表格项）
    sortSubmit(result, key = 'f', callback = null) {
      const rD = { id: this.userInfo.id }
      if (key === 'f') {
        if (!this.sortFilterKey) return
        rD[this.sortFilterKey] = JSON.stringify(result)
      } else if (key === 't') {
        if (!this.sortTableKey) return
        rD[this.sortTableKey] = JSON.stringify(result)
      }
      this.$api._user_modify(rD).then(res =>{
        if (res.data.status === 0) {
          this.$message.success('设置成功！')
          this.$api._user_userInfo(rD.id).then(res1 => {
            const data = JSON.parse(res1.data.data)
            this.userInfo_save(data)
          })
          callback()
          this.fillSortItems(result, key)
        } else { this._status(res.data) }
      })
    },
    // #endregion
    // #endregion
  },
}